<template>
    <div class="vue_flex vue_column">
        <div class="cont_wrapper">
            <div class="cont_wrapper_sx">
                <div class="shaixuan_left">
                    <div class="shaixuan_item h">
                        <div class="shaixuan_item_con">
                            <img class="shaixuan_item_icon" src="../../../../../assets/ym/tjsj@2x.png" alt="" />
                            <div class="shaixuan_item_tit">统计时间</div>
                        </div>
                        <el-date-picker v-model="listQuery.time" type="datetimerange" range-separator=""
                            start-placeholder="" end-placeholder="" value-format="timestamp" class="vue_flex_item"
                            placeholder="选择日期"></el-date-picker>
                    </div>
                    <div class="shaixuan_item h">
                        <div class="shaixuan_item_con">
                            <img class="shaixuan_item_icon" src="../../../../../assets/ym/qd@2x.png" alt="" />
                            <div class="shaixuan_item_tit">渠道</div>
                        </div>
                        <el-select v-model="listQuery.type" placeholder="请选择" class="vue_flex_item">
                            <el-option v-for="item in qudaooptions" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="shaixuan_btns">
                    <div class="shaixuan_btn1 h" @click="qingchu">清除</div>
                    <div class="shaixuan_btn2 h" @click="search">查询</div>
                </div>
            </div>
            <div class="home_title">
                <div class="home_tit">全渠道核心指标趋势</div>
                <!-- <div class="home_right">
          <div class="home_right_1">
            <div>日</div>
            <img src="../../../../../assets/ym/xl@2x.png" alt="" />
          </div>
          <img
            class="home_right_2"
            src="../../../../../assets/ym/gd@2x.png"
            alt=""
          />
        </div> -->
            </div>

            <linkboxs :list="linkList" @itemClick="linkboxsClick"></linkboxs>

            <div id="myChart"></div>
            <div class="home_title">
                <div class="home_tit">明细数据表</div>
            </div>

            <el-table :data="tableData" style="width: 100%"
                :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#333' }"
                :span-method="(...arg) => strategySpanMethod(...arg, tableData)" key="paycaliber">
                <el-table-column fixed prop="riqi" label="统计时间" align="center"></el-table-column>
                <el-table-column prop="qudaoName" label="渠道" align="center"></el-table-column>
                <el-table-column prop="shopName" label="店铺名称" align="center"></el-table-column>
                <el-table-column prop="maolirun" :label="tabsId == 1 ? '毛利（支付）' : '毛利（发货）'"
                    align="center"></el-table-column>
                <el-table-column prop="maolilv" :label="tabsId == 1 ? '毛利率 %（支付）' : '毛利率 %（发货）'"
                    align="center"></el-table-column>
                <el-table-column prop="yewulirun" label="业务利润（支付）" align="center"></el-table-column>
                <el-table-column prop="yewulirunlv" label="业务利润率 %（支付）" align="center"></el-table-column>
                <el-table-column prop="xiaoshoushouru" label="销售收入（去退）" align="center"></el-table-column>
                <el-table-column prop="xiaoshounum" label="销售数量" align="center"></el-table-column>
                <el-table-column prop="shouhoumoney" label="售后金额" align="center"></el-table-column>
                <el-table-column prop="tuikuailv" label="退款率 %（支付）" align="center"></el-table-column>
                <el-table-column prop="fahuoqiantuikuanjine" label="发货前退款金额" align="center"></el-table-column>
                <el-table-column prop="fahuobegintuikuanlv" label="发货前退款率 %（支付）" align="center"></el-table-column>
                <el-table-column prop="fahuohoutuikuanjine" label="发货后退款金额" align="center"></el-table-column>
                <el-table-column prop="fahuoendtuikuanlv" label="发货后退款率 %（支付）" align="center"></el-table-column>
                <el-table-column prop="yewuchengben" label="业务成本（利润）" align="center"></el-table-column>
                <el-table-column prop="xianshangguanggaotoufangfeiyong" label="线上广告投放费用"
                    align="center"></el-table-column>
                <el-table-column prop="guanggaobi" label="广告投放费比" align="center"></el-table-column>
                <el-table-column prop="pingtaigudingkoudian" label="平台固定扣点" align="center"></el-table-column>
                <el-table-column prop="pingtaiqitakoukuan" label="平台其它扣款" align="center"></el-table-column>
                <el-table-column prop="pingtaiyingxiaohuodong" label="平台营销活动" align="center"></el-table-column>
                <el-table-column prop="teshudanfeiyong" label="特殊单费用" align="center"></el-table-column>

                <el-table-column prop="baozhuangfeiyong" label="包装费用" align="center"></el-table-column>
                <el-table-column prop="kuaidifeiyong" label="快递费用" align="center"></el-table-column>
                <el-table-column prop="zengpinfeiyong" label="赠品费用" align="center"></el-table-column>
                <el-table-column prop="paishefeiyong" label="拍摄费用" align="center"></el-table-column>
                <el-table-column prop="cangchufeiyong" label="仓储费用" align="center"></el-table-column>
                <el-table-column prop="guanlifeiyong" label="管理费用" align="center"></el-table-column>
                <el-table-column prop="kaifafeiyong" label="开发费用" align="center"></el-table-column>
                <el-table-column prop="rengongzhichu" label="人工支出" align="center"></el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="listQuery1.page" :limit.sync="listQuery1.limit"
                @pagination="getList" />
        </div>
    </div>
</template>
<script>
import Cookies from "js-cookie";
import * as echarts from "echarts";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import linkboxs from "@/components/linkdata/index";
import DonMessage from "@/utils/message";

export default {
    components: { Pagination, linkboxs },

    data() {
        return {
            total: 0,
            listQuery: {
                time: [],
                type: "",
                shopid: "",
            },
            listQuery1: {
                page: 1,
                limit: 10,
                leixing: "",
            },
            tabsId: 1,
            charts: "",
            opinionData: ["3", "2", "4", "4", "5"],
            linkList: [
                {
                    tit: "销售收入",
                    num: "",
                    bi: "日环比   %",
                    img: require("../../../../../assets/ym/xssr.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "销售订单数",
                    num: "",
                    bi: "日环比   %",
                    img: require("../../../../../assets/ym/xsdds.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "销售金额",
                    num: "7234.87",
                    bi: "日环比   %",
                    img: require("../../../../../assets/ym/xsje.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "退款订单数",
                    num: "",
                    bi: "日环比   %",
                    img: require("../../../../../assets/ym/tkdds.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "线上广告投放费用",
                    num: "",
                    bi: "日环比   %",
                    img: require("../../../../../assets/ym/xsggtffy.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "广告投放费比",
                    num: "",
                    bi: "日环比   %",
                    img: require("../../../../../assets/ym/ggtffb.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "退款率（支付）",
                    num: "",
                    bi: "发货前退款率（支付）   %",
                    bihou: "发货后退款率（支付）   %",
                    img: require("../../../../../assets/ym/tkl.png"),
                    height: 181,
                    width: 367,
                },
                {
                    tit: "业务利润（支付）",
                    num: "",
                    bi: "业务利润率（支付）%",
                    img: require("../../../../../assets/ym/xsdds.png"),
                    height: 181,
                    width: 367,
                },
            ],

            userObj: {},
            tableData: [],

            value1: "",
            dpList: [],

            qudaooptions: [
                { value: "1", label: "淘宝" },
                { value: "2", label: "京东" },
                { value: "3", label: "拼多多" },
            ],
        };
    },

    created() {
        this.getList();
        this.getdpListFun();
        this.getzftb();
        this.getdataList();
        this.getHuanbi();
    },

    methods: {
        getSpanArr(data, spanKey) {
            var spanArr = [];
            var pos = "";
            for (var i = 0; i < data.length; i++) {
                if (i === 0) {
                    spanArr.push(1);
                    pos = 0;
                } else {
                    // 判断当前元素与上一个元素是否相同
                    if (data[i][spanKey] === data[i - 1][spanKey]) {
                        spanArr[pos] += 1;
                        spanArr.push(0);
                    } else {
                        spanArr.push(1);
                        pos = i;
                    }
                }
            }
            return spanArr;
        },

        search() {
            this.getList();
            this.getzftb();
            this.getHuanbi();
            this.tableData = [];
            this.getdataList();
        },

        linkboxsClick(msg) {
            console.log('msg-->', msg);
            this.$nextTick(function () {
                this.drawLine("myChart", msg.tubiao);
            });
        },

        async getList() {
            let params = {
                type: this.listQuery.type,
                shopid: this.listQuery.shopid,
                starttime:
                    this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
                endtime:
                    this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
            };
            const res = await this.$http.post(this.$urls.lirunribao_zhifu, params);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            for (let key of this.linkList) {
                if (key.tit == "销售收入") {
                    key.num = res.xiaoshoushouru;
                    // key.bi = "日环比" + 0 + '%';
                }
                if (key.tit == "销售订单数") {
                    key.num = res.dingdannum;
                    // key.bi = "日环比" + 0 + '%';
                }
                if (key.tit == "销售金额") {
                    key.num = res.xiaoshoujinezhifu;
                    // key.bi = "日环比" + 0 + '%';
                }
                if (key.tit == "退款订单数") {
                    key.num = res.tuikuanshuliang;
                    // key.bi = "日环比" + 0 + '%';
                }
                if (key.tit == "线上广告投放费用") {
                    key.num = res.tuiguangmoney;
                    // key.bi = "日环比" + 0 + '%';
                }
                if (key.tit == "广告投放费比") {
                    key.num = res.guanggaobi;
                    // key.bi = "日环比" + 0 + '%';
                }
                if (key.tit == "退款率（支付）") {
                    key.num = res.tuikuailv;
                    key.bi = "发货前退款率（支付)" + res.fahuobegintuikuanlv + '%';
                    key.bihou = "发货后退款率（支付）" + res.fahuoendtuikuanlv + '%';
                }
                if (key.tit == "业务利润（支付）") {
                    key.num = res.yewulirun;
                    key.bi = "业务利润率" + res.yewulirunlv + '%';
                }
            }
        },

        async getHuanbi() {
            let today = new Date();
            let todayTime = this.getDayStartAndEndTimestamp(today);
            console.log("今天开始时间戳（十位数）：", todayTime.start);
            console.log("今天结束时间戳（十位数）：", todayTime.end);
            let params1 = {
                type: this.listQuery.type,
                shopid: this.listQuery.shopid,
                starttime: todayTime.start,
                endtime: todayTime.end,
            };
            const res1 = await this.$http.post(this.$urls.lirunribao_zhifu, params1);
            if (res1.errcode != 0) return DonMessage.error(res1.errmsg);


            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1); // 日期减1，得到昨天
            let yesterdayTime = this.getDayStartAndEndTimestamp(yesterday);
            console.log("昨天开始时间戳（十位数）：", yesterdayTime.start);
            console.log("昨天结束时间戳（十位数）：", yesterdayTime.end);
            let params2 = {
                type: this.listQuery.type,
                shopid: this.listQuery.shopid,
                starttime: yesterdayTime.start,
                endtime: yesterdayTime.end,
            };
            const res2 = await this.$http.post(this.$urls.lirunribao_zhifu, params2);
            if (res2.errcode != 0) return DonMessage.error(res2.errmsg);

            for (let key of this.linkList) {
                if (key.tit == "销售收入") {
                    key.bi = "日环比" + this.calculateDailyMoM(res1.xiaoshoushouru, res2.xiaoshoushouru);
                }
                if (key.tit == "销售订单数") {
                    key.bi = "日环比" + this.calculateDailyMoM(res1.dingdannum, res2.dingdannum);
                }
                if (key.tit == "销售金额") {
                    key.bi = "日环比" + this.calculateDailyMoM(res1.xiaoshoujinezhifu, res2.xiaoshoujinezhifu);
                }
                if (key.tit == "退款订单数") {
                    key.bi = "日环比" + this.calculateDailyMoM(res1.tuikuanshuliang, res2.tuikuanshuliang);
                }
                if (key.tit == "线上广告投放费用") {
                    key.bi = "日环比" + this.calculateDailyMoM(res1.tuiguangmoney, res2.tuiguangmoney);
                }
                if (key.tit == "广告投放费比") {
                    key.bi = "日环比" + this.calculateDailyMoM(res1.guanggaobi, res2.guanggaobi);
                }

            }
        },
        getDayStartAndEndTimestamp(targetDate) {
            // 克隆日期对象，避免修改原对象
            const date = new Date(targetDate);

            // 设置为当天 00:00:00
            date.setHours(0, 0, 0, 0);
            const startTimestamp = Math.floor(date.getTime() / 1000); // 转秒级并取整

            // 设置为当天 23:59:59
            date.setHours(23, 59, 59, 999);
            const endTimestamp = Math.floor(date.getTime() / 1000); // 转秒级并取整

            return {
                start: startTimestamp,
                end: endTimestamp
            };
        },
        calculateDailyMoM(todayValue, yesterdayValue, isPercent = true) {
            // 1. 类型校验与转换，确保参数为有效数字
            const today = todayValue;
            const yesterday = yesterdayValue;


            // 2. 规避分母为0的情况（核心：昨日值为0时无法计算环比，返回null并提示）
            if (yesterday == 0) {
                // 3. 核心公式计算环比增长率（小数形式）
                const moMRate = (today - yesterday) / 1;

                // 4. 处理最多两位小数（四舍五入，自动保留1-2位小数，不强制补零）
                // 原理：先放大100倍取整（实现四舍五入），再缩小100倍，得到最多两位小数的数字
                const moMRateFixed = Math.round(moMRate * 100) / 100;

                // 5. 根据需求返回小数格式或百分比格式
                if (isPercent) {
                    // 百分比格式：先保留两位小数（避免出现1.2%这种一位小数，统一格式可读性更强），拼接%
                    return (moMRate * 100).toFixed(2) + "%";
                }

                return moMRateFixed;
            }

            // 3. 核心公式计算环比增长率（小数形式）
            const moMRate = (today - yesterday) / yesterday;

            // 4. 处理最多两位小数（四舍五入，自动保留1-2位小数，不强制补零）
            // 原理：先放大100倍取整（实现四舍五入），再缩小100倍，得到最多两位小数的数字
            const moMRateFixed = Math.round(moMRate * 100) / 100;

            // 5. 根据需求返回小数格式或百分比格式
            if (isPercent) {
                // 百分比格式：先保留两位小数（避免出现1.2%这种一位小数，统一格式可读性更强），拼接%
                return (moMRate * 100).toFixed(2) + "%";
            }

            return moMRateFixed;
        },

        async getdataList() {
            let params = {
                page: this.listQuery1.page,
                limit: this.listQuery1.limit,
                leixing: "zhichu",
                starttime:
                    this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
                endtime:
                    this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
            };
            const res = await this.$http.get(this.$urls.lirunribao_excel, params);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            res.allData.forEach((dateItem) => {
                const { riqi, qudao } = dateItem;
                // 遍历每个渠道
                qudao.forEach((channelItem) => {
                    const { name: qudaoName, shopList } = channelItem;
                    // 渠道无店铺时，生成空店铺行（保证日期合并完整性）
                    if (shopList.length === 0) {
                        this.tableData.push({
                            riqi,
                            qudaoName,
                            shopName: "-",
                            xiaoshoushouru: "0.00",
                            xiaoshounum: 0,
                            dingdannum: 0,
                            maolilv: "-",
                            maolirun: "-",
                            yewu: "-",
                        });
                    } else {
                        // 有店铺时，遍历店铺生成行
                        shopList.forEach((shopItem) => {
                            this.tableData.push({
                                riqi,
                                qudaoName,
                                ...shopItem,
                                // shopName: shopItem.name,
                                // xiaoshoushouru: shopItem.xiaoshoushouru,
                                // xiaoshounum: shopItem.xiaoshounum,
                                // dingdannum: shopItem.dingdannum,
                                // maolilv: shopItem.maolilv,
                                // maolirun: shopItem.maolirun,
                                // yewu: shopItem.yewu,
                            });
                        });
                    }
                });
            });
        },
        // 合并单元格函数
        strategySpanMethod: function (
            { row, column, rowIndex, columnIndex },
            data
        ) {
            if (columnIndex !== 0) return;
            // data 就是从这里动态传过来的, column.property是表头的key
            var spanArr = this.getSpanArr(data, column.property);
            const _row = spanArr[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
                rowspan: _row,
                colspan: _col,
            };
        },

        qingchu() {
            this.listQuery = {
                time: [],
                type: "",
                shopid: "",
            };
            this.getList();
        },

        async getzftb() {
            const res = await this.$http.get(this.$urls.lirunribao_zhifu_echart, {
                type: this.listQuery.type,
                shopid: this.listQuery.shopid,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);

            for (let key of this.linkList) {
                if (key.tit == "销售收入") {
                    key.tubiao = res.xiaoshoushouruEcharts;
                }
                if (key.tit == "销售订单数") {
                    key.tubiao = res.dingdannumEcharts;
                }
                if (key.tit == "销售金额") {
                    key.tubiao = res.xiaoshoujinezhifuEcharts;
                }
                if (key.tit == "退款订单数") {
                    key.tubiao = res.tuikuanshuliangEcharts;
                }
                if (key.tit == "线上广告投放费用") {
                    key.tubiao = res.tuiguangmoneyEcharts;
                }
                if (key.tit == "广告投放费比") {
                    key.tubiao = res.guanggaobiEcharts;
                }
                if (key.tit == "退款率（支付）") {
                    key.tubiao = res.tuikuailvEcharts;
                }
                if (key.tit == "业务利润（支付）") {
                    key.tubiao = res.yewulirunEcharts;
                }
            }
            this.$nextTick(function () {
                this.drawLine("myChart", res.yewulirunEcharts);
            });
        },

        // 店铺列表
        async getdpListFun() {
            const res = await this.$http.get(this.$urls.getshoplist, {
                page: 1,
                limit: 10000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dpList = res.list;
        },

        drawLine(id, item) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption({
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: [""],
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "12%",
                    containLabel: true,
                },

                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: item.x,
                },
                yAxis: {
                    type: "value",
                },

                series: [
                    {
                        name: "近七日",
                        type: "line",
                        stack: "总量",
                        data: item.y,
                    },
                ],
            });
        },

        getHetongListFun() { },
    },
};
</script>

<style lang="scss" scoped>
#myChart {
    width: 1508px;
    height: 300px;
    background: #ffffff;
}

.home_title {
    width: 100%;
    height: 55px;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .home_tit {
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 26px;
        color: #232323;
    }

    .home_right {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;

        .home_right_2 {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            margin-left: 10px;
        }

        .home_right_1 {
            padding: 0 10px;
            width: 108px;
            height: 45px;
            background: #f4f5f9;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
        }
    }
}

.shaixuan_btns {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;

    .shaixuan_btn1 {
        width: 132px;
        height: 55px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #999999;
        text-align: center;
        line-height: 55px;
    }

    .shaixuan_btn2 {
        margin-left: 25px;
        width: 131px;
        height: 54px;
        background: #195cf8;
        border-radius: 10px;
        text-align: center;
        line-height: 55px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
    }
}

.cont_wrapper {
    padding: 25px;

    .cont_wrapper_sx {
        width: 1527px;
        height: 71px;
        background: #f5f5f5;
        border-radius: 10px;
        padding: 0 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .shaixuan_left {
            display: flex;
            flex-direction: row;
            justify-content: start;
            align-items: center;
        }

        .shaixuan_item {
            width: 350px;
            height: 54px;
            background: #ffffff;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            margin-right: 22px;

            .shaixuan_item_con {
                display: flex;
                flex-direction: row;
                justify-content: start;
                align-items: center;

                .shaixuan_item_tit {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #232323;
                }

                .shaixuan_item_sel {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #999999;
                }

                .shaixuan_item_arr {
                    width: 13px;
                    height: 8px;
                    margin-left: 10px;
                }

                .shaixuan_item_icon {
                    width: 29px;
                    height: 24px;
                    margin-right: 10px;
                }
            }
        }
    }
}

.shaixuan_item {
    /deep/ .el-date-editor {
        border: none !important;
        text-align: right;
        font-size: 18px;
        width: 196px;
    }

    /deep/ .el-input__icon {
        display: none;
    }

    .el-input /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }

    .el-input /deep/.el-input__prefix {
        display: none !important;
    }

    .el-select /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/channel/channelcore/index.vue